import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mic } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_ruonn-replica/artifacts/652j8z6m_logo%20letra%20transparente%20white.png';

const Header = ({ onOpenModal }) => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0b]/80 backdrop-blur-md border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center">
          <img 
            src={LOGO_URL} 
            alt="Ruonn - Expert Developers & QA Services" 
            className="h-10 w-auto"
          />
        </a>

        {/* Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <button 
            onClick={() => scrollToSection('benefits')}
            className="text-gray-400 hover:text-white transition-colors text-sm"
          >
            Why Ruonn
          </button>
          <Link 
            to="/voice-agent"
            className="text-gray-400 hover:text-white transition-colors text-sm"
          >
            AI Voice Agent
          </Link>
          <button 
            onClick={() => scrollToSection('how-it-works')}
            className="text-gray-400 hover:text-white transition-colors text-sm"
          >
            How it Works
          </button>
          <button 
            onClick={() => scrollToSection('testimonials')}
            className="text-gray-400 hover:text-white transition-colors text-sm"
          >
            Testimonials
          </button>
          <button 
            onClick={() => scrollToSection('faq')}
            className="text-gray-400 hover:text-white transition-colors text-sm"
          >
            FAQ
          </button>
        </nav>

        {/* CTA Buttons */}
        <div className="flex items-center gap-3">
          <Link
            to="/cloud/login"
            className="hidden sm:flex items-center gap-2 border border-purple-500/50 text-purple-400 hover:bg-purple-500/10 px-4 py-2 rounded-full text-sm font-medium transition-all"
          >
            <Mic className="w-4 h-4" />
            Ruonn Cloud
          </Link>
          <button
            onClick={onOpenModal}
            className="flex items-center gap-2 bg-[#7c3aed] hover:bg-[#6d28d9] text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105"
          >
            <Phone className="w-4 h-4" />
            Book a call
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
